import React from 'react';
import { LoanStatusType } from '@apply/constants';
import { Column } from 'devextreme-react/data-grid';
import { getLoanRepaidStatusColumnHtml } from '../LoanFunctions';

interface LoanRepaidIndicatorColumnParameters {
    statusId: LoanStatusType;
}

export const LoanRepaidIndicatorColumn: React.FC<LoanRepaidIndicatorColumnParameters> = ({ statusId }) => {
    const onRepaidStatusCellRender = (e) => {
        return getLoanRepaidStatusColumnHtml(e.value);
    };

    if (statusId == LoanStatusType.Outstanding) {
        return [
            <Column
                key='repaidStatusId'
                dataField='repaidStatusId'
                caption='Repaid'
                dataType='number'
                cellRender={onRepaidStatusCellRender}
                width={90}
                alignment={'center'}
            />,
        ];
    }
};
